<template>
    <header class="header">
      <div class="container">
        <div class="logo-section">
          <img src="../../assets/support.svg" alt="Logo" class="logo" />
          <h1 class="app-name">Support Portal</h1>
        </div>
        <nav class="navigation">
          <ul class="nav-list">
            <li>
              <router-link 
                to="/user/support" 
                class="nav-link" 
                :class="{ active: $route.path === '/user/support' }"
              >
                User Information
              </router-link>
            </li>
            <li>
              <router-link 
                to="/course/support" 
                class="nav-link" 
                :class="{ active: $route.path === '/course/support' }"
              >
                Product Variant Information
              </router-link>
            </li>
          </ul>
        </nav>
        <button @click="logout" class="logout-button">
          <svg xmlns="http://www.w3.org/2000/svg" class="logout-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
          </svg>
          Logout
        </button>
      </div>
    </header>
  </template>
  <script>
  export default {
    name: 'HeaderComponent',
    methods: {
      logout() {
        // Implement logout logic here
        console.log('Logout clicked');
        localStorage.clear();
        this.$router.push('/');
      }
    }
  }
  </script>
  
  <style scoped>
  .header {
    background-color: #1a202c;
    color: #ffffff;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
  
  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  
  .logo-section {
    display: flex;
    align-items: center;
    gap: 1rem;
  }
  
  .logo {
    height: 2rem;
    width: 2rem;
  }
  
  .app-name {
    font-size: 1.25rem;
    font-weight: bold;
  }
  
  .navigation {
    flex-grow: 1;
    margin-left: 2rem;
  }
  
  .nav-list {
    display: flex;
    gap: 6.5rem;
    list-style-type: none;
    padding: 0;
    margin: 0;
    justify-content: center;
  }
  
  .nav-link {
    color: #ffffff;
    text-decoration: none;
    font-size: 1rem;
    transition: color 0.15s ease-in-out;
  }
  
  .nav-link:hover {
    color: #cbd5e0;
  }
  
  .logout-button {
    background-color: #e53e3e;
    color: #ffffff;
    font-weight: bold;
    padding: 0.5rem 1rem;
    border-radius: 9999px;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    transition: background-color 0.15s ease-in-out;
  }
  
  .logout-button:hover {
    background-color: #c53030;
  }
  
  .logout-icon {
    height: 1.25rem;
    width: 1.25rem;
    margin-right: 0.5rem;
  }
  
  @media (max-width: 768px) {
    .container {
      flex-direction: column;
      align-items: flex-start;
    }
  
    .navigation {
      margin-left: 0;
      margin-top: 1rem;
      width: 100%;
    }
  
    .nav-list {
      flex-direction: column;
      gap: 0.5rem;
    }
  
    .logout-button {
      margin-top: 1rem;
      align-self: flex-start;
    }
  }

  </style>